module.exports = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="20px" viewBox="0 0 24 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
    <title>Artboard 15</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Artboard-15" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="laptop" transform="translate(1.000000, 1.000000)" stroke="#5E6D77">
            <g>
                <path d="M19.3111111,11.9777778 L19.3111111,1.22222222 C19.3111111,0.682 18.8735556,0.244444444 18.3333333,0.244444444 L3.66666667,0.244444444 C3.12644444,0.244444444 2.68888889,0.682 2.68888889,1.22222222 L2.68888889,11.9777778" id="Shape" stroke-width="1.375"></path>
                <path d="M19.3111111,11.9777778 L2.68888889,11.9777778 L0.462977778,16.4296 C0.137866667,17.0793333 0.610622222,17.8444444 1.3376,17.8444444 L20.6624,17.8444444 C21.3893778,17.8444444 21.8621333,17.0793333 21.5370222,16.4296 L19.3111111,11.9777778 Z" id="Shape" stroke-width="1.375"></path>
                <rect id="Rectangle-path" stroke-width="1.375" x="5.62222222" y="3.17777778" width="10.7555556" height="5.86666667"></rect>
            </g>
        </g>
    </g>
</svg>`;
